import { MarketingShell } from "@/components/landing/MarketingShell";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { SeoHead } from "@/components/useSeo";
import { Problems } from "@/components/landing/Problems";
import { DynamicVideo } from "@/components/landing/DynamicVideo";

const Page = () => (
  <MarketingShell>
    <SeoHead
      path="product-about"
      title="How It Works — DollarDeploy"
      description="See how DollarDeploy gets your app from localhost to a live URL in minutes — no DevOps required."
    />
    <section className="container py-20">
      <DynamicVideo />
      <Problems />
      <HowItWorks />
    </section>
  </MarketingShell>
);

export default Page;
